import { render, staticRenderFns } from "./headerShape.vue?vue&type=template&id=7e0b206a&scoped=true"
import script from "./headerShape.vue?vue&type=script&lang=js"
export * from "./headerShape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b206a",
  null
  
)

export default component.exports